// Vue js custom

import { createApp } from 'vue/dist/vue.esm-bundler';
import axios from 'axios';
import VueSelect from 'vue-select';
import VueScrollTo from 'vue-scrollto';
import { load as recaptchaLoad } from 'recaptcha-v3';

const loaderComponent = {
  template: `
    <div class="d-flex align-items-center justify-content-center mt-5">
      <div class="spinner-border text-blue-thin" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  `
};

// Vacancies list
const vueVacancyList = document.querySelector('#vueVacancyList');
if (vueVacancyList) {
  createApp({
    data: () => ({
      searchText: '',
      selectedProfession: '',
      selectedSpecialization: '',
      selectedLocation: '',
      filter: {},
      vacancies: [],
      loading: false,
      pagination: {
        page: 1,
        pages: [],
        perPage: 10
      }
    }),
    mounted() {
      this.fetchData()
    },
    computed: {
      displayedItems() {
        return this.paginate(this.filteredVacancies);
      },
      filteredVacancies() {
        return this.vacancies
          .slice()
          .filter(item => {
            return this.searchText !== '' ? item.name.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1 : true
          })
          .filter(item => {
            return this.selectedProfession !== '' ? item.profession.id === this.selectedProfession : true
          })
          .filter(item => {
            return this.selectedSpecialization !== '' ? (item.specialization ? item.specialization.id : '') === this.selectedSpecialization : true
          })
          .filter(item => {
            return this.selectedLocation !== '' ? item.locations.find(item => item.id === this.selectedLocation) : true
          });
      },
      isFilteredVacanciesNotEmpty() {
        return this.filteredVacancies.length > 0
      },
      filteredSpecializations() {
        let specializations = []
        this.filteredVacancies.map(item => {
          if (item.specialization && !specializations.find(s => s.id === item.specialization.id)) specializations.push(item.specialization)
        })
        return specializations
      }
    },
    watch: {
      filteredVacancies() {
        this.setPages();
      },
      'pagination.page': function () {
        $('html, body').animate({
          scrollTop: $('#vueVacancyList').offset().top - $('.Navigation').outerHeight(true)
        }, 500);
      }
    },
    methods: {
      setPages() {
        this.pagination.pages = [];
        this.pagination.page = 1;

        let numberOfPages = Math.ceil(this.filteredVacancies.length / this.pagination.perPage);
        for (let index = 1; index <= numberOfPages; index++) {
          this.pagination.pages.push(index);
        }
      },
      paginate(items) {
        let page = this.pagination.page;
        let perPage = this.pagination.perPage;
        let from = (page * perPage) - perPage;
        let to = (page * perPage);
        return items.slice(from, to);
      },
      getProfession(id) {
        return this.filter.professions.find(item => item.id === id).name
      },
      getSpecialization(id) {
        return this.filter.specializations.find(item => item.id === id).name
      },
      getLocations(locations) {
        const names = []
        locations.map(location => {
          let name = this.filter.locations.find(item => item.id === location.id)?.name;

          if (name) {
            names.push(name);
          }
        })
        return names
      },
      fetchData() {
        this.loading = true;
        const url = `/umbraco/api/Vacancy/GetList?culture=cs`;
        axios
          .get(url)
          .then(response => {
            this.loading = false;
            const { data } = response;
            this.filter = data.filter
            this.vacancies = data.vacancies
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      }
    }
  })
    .use(VueScrollTo)
    .component('v-select', VueSelect)
    .component('loader', loaderComponent)
    .mount('#vueVacancyList');
}

// Doctors list
const vueDoctorsList = document.querySelector('#vueDoctorsList');
if (vueDoctorsList) {
  createApp({
    mounted() {
      this.fetchData()
    },
    data: () => ({
      doctors: [],
      clinics: [],
      specializations: [],
      languages: [],
      selectedClinic: '',
      selectedSpecialization: [],
      selectedLanguages: '',
      searchQuery: '',
      pediatrianOnly: false,
      isDataLoaded: false,
      loading: false,
      pagination: {
        page: 1,
        pages: [],
        perPage: 10
      }
    }),
    computed: {
      displayedItems() {
        return this.paginate(this.filteredDoctors);
      },
      filteredDoctors() {
        return this.doctors.slice()
          // Clinics
          .filter(item =>
            this.selectedClinic ? item.clinics.includes(this.selectedClinic.id) : true
          )
          // Specializations
          .filter(item =>
            this.selectedSpecialization.length !== 0 ? this.selectedSpecialization.some((v => item.specializations.includes(v.id))) : true
          )
          // Languages
          .filter(item =>
            this.selectedLanguages ? this.selectedLanguages.every((v => item.languages.includes(v.id))) : true
          )
          // Pediators only
          .filter(item =>
            this.pediatrianOnly ? item.isChildDoctor : true
          )
          // Fulltext
          .filter(item => {
            if (!this.searchQuery || !item.name) return true
            const name = item.name.toLowerCase()
            const specializations = item.specializations.map(id => {
              return this.specializations.find(spec => spec.id === id).name.toLowerCase()
            }).join(' ')
            const searchSource = name.concat(' ', specializations)
            return searchSource.includes(this.searchQuery.toLowerCase())
          })
      },
      specializationsByClinic() {
        let specializationsIDs = [];
        this.doctors.map(doctor => {
          let isDoctorIn = this.selectedClinic ? doctor.clinics.includes(this.selectedClinic.id) : true
          if (isDoctorIn) {
            specializationsIDs = specializationsIDs.concat(doctor.specializations)
          }
        })
        const specializations = [...new Set(specializationsIDs)].map(specializationID => {
          return this.specializations.find(specialization => {
            if (specialization.id === specializationID) {
              return specialization
            }
          })
        })
        return specializations.sort((a, b) => a.name.localeCompare(b.name, 'cs'))
      },
      clinicsBySpecialization() {
        let clinicsIDs = [];
        this.doctors.map(doctor => {
          const isDoctorIn = this.selectedSpecialization.length !== 0 ? this.selectedSpecialization.some((v => doctor.specializations.includes(v.id))) : true
          if (isDoctorIn) {
            clinicsIDs = clinicsIDs.concat(doctor.clinics)
          }
        })
        return this.clinics.filter(clinic => clinicsIDs.includes(clinic.id))
      },
      isDoctorsListEmpty() {
        return this.filteredDoctors.length === 0
      }
    },
    methods: {
      setPages() {
        this.pagination.pages = [];
        this.pagination.page = 1;

        let numberOfPages = Math.ceil(this.filteredDoctors.length / this.pagination.perPage);
        for (let index = 1; index <= numberOfPages; index++) {
          this.pagination.pages.push(index);
        }
      },
      paginate(items) {
        let page = this.pagination.page;
        let perPage = this.pagination.perPage;
        let from = (page * perPage) - perPage;
        let to = (page * perPage);
        return items.slice(from, to);
      },
      resetFilter() {
        this.selectedClinic = ''
        this.selectedSpecialization = []
        this.selectedLanguages = ''
        this.pediatrianOnly = false
      },
      fetchData() {
        const url = `/umbraco/api/Workplace/Search?culture=${window.lang}`;
        const options = {
          method: 'POST',
          config: {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
          },
          url
        };
        this.loading = true
        axios(options)
          .then(response => {
            const { data } = response;
            this.doctors = data.workplaces
            this.specializations = data.specializations
            this.clinics = data.clinics
            this.languages = data.languages
            if (window.selectedSpecialization) {
              this.selectedSpecialization.push(this.getSpecialization(+window.selectedSpecialization[0]))
            }
            if (window.selectedClinic) {
              this.selectedClinic = this.getClinic(+window.selectedClinic)
            }
            if (window.selectedLanguage) {
              this.selectedLanguages.push(this.getLanguage(+window.selectedLanguage[0]))
            }

            // set selectedClinic from url param (if any)
            const selectedClinicIdParam = new URL(window.location).searchParams.get('selectedClinic')
            if (selectedClinicIdParam) {
              this.selectedClinic = this.getClinic(Number(selectedClinicIdParam))
            }

            // set selectedSpecialization from url param (if any)
            const selectedSpecializationIdsParam = new URL(window.location).searchParams.get('selectedSpecialization')
            if (selectedSpecializationIdsParam) {
              this.selectedSpecialization = JSON.parse(selectedSpecializationIdsParam).map(item => Number(item)).map(id => this.getSpecialization(id));
            }

            // set selectedLanguages from url param (if any)
            const selectedLanguagesIdsParam = new URL(window.location).searchParams.get('selectedLanguages')
            if (selectedLanguagesIdsParam) {
              this.selectedLanguages = JSON.parse(selectedLanguagesIdsParam).map(item => Number(item)).map(id => this.getLanguage(id));
            }

            // set pediatrianOnly from url param (if any)
            const pediatrianOnlyParam = new URL(window.location).searchParams.get('pediatrianOnly')
            if (pediatrianOnlyParam) {
              this.pediatrianOnly = true;
            }

            this.isDataLoaded = true
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            console.log(error);
          });
      },
      getSpecializations(ids) {
        return ids.map(id => this.specializations.find(item => item.id === id).name)
      },
      getSpecialization(id) {
        return this.specializations.find(item => item.id === id)
      },
      getClinics(ids) {
        return ids.map(id => this.clinics.find(item => item.id === id).name)
      },
      getClinic(id) {
        return this.clinics.find(item => item.id === id)
      },
      getLanguages(ids) {
        return ids.map(id => this.languages.find(item => item.id === id).name)
      },
      getLanguage(id) {
        return this.languages.find(item => item.id === id)
      },
      scrollToTop() {
        this.$scrollTo(this.$refs.doctorsList, 200, {
          offset: -$('.Navigation').outerHeight(true)
        })
      }
    },
    watch: {
      selectedClinic(newValue, oldValue) {
        // save id to url
        const url = new URL(window.location)

        if (newValue?.id) {
          url.searchParams.set('selectedClinic', newValue.id);
        }
        else {
          url.searchParams.delete('selectedClinic')
        }

        history.pushState(null, '', url)
      },
      selectedSpecialization(newValue, oldValue) {
        // save id to url
        const url = new URL(window.location)

        if (newValue.length) {
          const jsonIdsArray = JSON.stringify(newValue.map(item => item.id));
          url.searchParams.set('selectedSpecialization', jsonIdsArray);
        }
        else {
          url.searchParams.delete('selectedSpecialization')
        }

        history.pushState(null, '', url)
      },
      selectedLanguages(newValue, oldValue) {
        // save id to url
        const url = new URL(window.location)

        if (newValue.length) {
          const jsonIdsArray = JSON.stringify(newValue.map(item => item.id));
          url.searchParams.set('selectedLanguages', jsonIdsArray);
        }
        else {
          url.searchParams.delete('selectedLanguages')
        }

        history.pushState(null, '', url)
      },
      pediatrianOnly(newValue, oldValue) {
        // save to url
        const url = new URL(window.location)

        if (newValue) {
          url.searchParams.set('pediatrianOnly', newValue);
        }
        else {
          url.searchParams.delete('pediatrianOnly')
        }

        history.pushState(null, '', url)
      },
      filteredDoctors() {
        this.setPages();
      },
      'pagination.page': function () {
        $('html, body').animate({
          scrollTop: $('#vueDoctorsList').offset().top - $('.Navigation').outerHeight(true)
        }, 500);
      }
    }
  })
    .use(VueScrollTo)
    .component('v-select', VueSelect)
    .component('loader', loaderComponent)
    .mount('#vueDoctorsList');
}